import { getMedia } from 'yxt-biz-pc/packages/api';

export default {
  computed: {
    mediaPath() {
      return getMedia() + 'common/biz_svg';
    }
  }
};
